<template>
  <div
    v-loading="boxLoading"
    class="pdf-preview-out"
  >
    <!-- 上部 外层容器 用于滚动-->
    <div class="scroll-box">
      <!-- 用于截取调缩放后的空白区域 -->
      <div class="pdf-box">
        <!-- pdf预览区域(会被缩放) -->
        <div
          style="position: relative"
          :style="getPdfSize()"
          class="pdf-scale-box"
        >
          <!-- 预览组件 -->
          <pdf
            ref="myPdf"
            :src="url"
            :page="currentPage"
            @num-pages="getTotalPage"
            @page-loaded="pageLoaded"
            @loaded="mountedLoaded"
          />
          <div ref="canvas" style="position: absolute;height: 100%;width: 100%;top: 0">
            <div style="position: relative" :style="markStyle" />
          </div>
        </div>
      </div>
    </div>

    <!-- 底部操作栏 -->
    <div class="bottom-tools">
      <div class="page-info">
        Page {{ currentPage }} of {{ pageTotal }}
      </div>
      <div class="page">
        <el-button
          size="small"
          :type="currentPage === 1 ? 'info' : 'primary'"
          :disabled="currentPage === 1"
          @click="chengPage"
        >
          <i class="el-icon-arrow-left"></i>
          Previous
        </el-button>
        <el-button
          size="small"
          :type="currentPage === pageTotal ? 'info' : 'primary'"
          :disabled="currentPage === pageTotal"
          @click="chengPage('+')"
        >
          Next
          <i class="el-icon-arrow-right"></i>
        </el-button>
        <div class="page-jump">
          <span>Go to</span>
          <el-input 
            v-model="pageInputValue" 
            size="small"
            @change="pageChangeEnter"
          />
          <span>page</span>
        </div>
      </div>

      <div class="tools-group">
        <!-- 旋转按钮组 -->
        <div class="scale">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-refresh-left"
            circle
            @click="rotateCounterclockwise"
          />
          <el-button
            size="small"
            type="primary"
            icon="el-icon-refresh-right"
            circle
            @click="rotateClockwise"
          />
        </div>

        <div class="divider"></div>

        <!-- 缩放按钮组 -->
        <div class="scale">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-minus"
            circle
            :disabled="(pageScale - 0.1) < 0.3"
            @click="scalePage"
          />
          <el-button
            size="small"
            type="primary"
            icon="el-icon-plus"
            circle
            :disabled="(pageScale + 0.1) > 2"
            @click="scalePage('+')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 插件引入
import pdf from 'vue-pdf'
export default {
  name: 'MyPdfView',
  components: {
    pdf
  },
  props: {
    // pdf预览的地址 由父组件中传入 也可在本组件中直接赋值
    url: {
      type: String,
      default: ''
    },
    markData: {}
  },
  data() {
    return {
      pageInputValue: '',
      markStyle: '', // 标注样式
      // 总页数
      pageTotal: 0,
      // 当前页
      currentPage: 1,
      // 缩放比例
      pageScale: 1,
      // 旋转角度
      rotateAngle: 0,
      // 遮罩
      boxLoading: true,
      pageChangeTimer: null
    }
  },
  watch: {
    url: {
      deep: true,
      handler() {
        this.pageTotal = 0
        this.currentPage = 1
        this.pageScale = 1
        this.rotateAngle = 0
        this.boxLoading = true
        this.pageChangeTimer = null
      }
    },
    markData: {
      deep: true,
      handler(data) {
        console.log('myPdfView received markData:', data)
        if (data && data.page) {
          console.log('Changing to page:', data.page)
          this.currentPage = data.page
        }
        this.dealMark(data)
      }
    },
    currentPage: {
      handler(newPage) {
        console.log('Current page changed to:', newPage)
        this.$emit('pageChange', newPage)
      }
    }
  },
  methods: {
    dealMark(data) {
      console.log('dealMark called with data:', data)
      if (!data) {
        this.markStyle = ''
        return
      }

      if (data.page && data.page !== this.currentPage) {
        console.log('Setting current page to:', data.page)
        this.currentPage = data.page
      }

      const bounding_box = data.bounding_box
      if (bounding_box && bounding_box.length === 8) {
        console.log('Processing bounding box:', bounding_box)
        
        // 等待 canvas 元素加載
        this.$nextTick(() => {
          if (!this.$refs.canvas) {
            console.error('Canvas ref not found')
            return
          }

          const canvasWidth = this.$refs.canvas.offsetWidth
          const canvasHeight = this.$refs.canvas.offsetHeight
          
          console.log('Canvas dimensions:', { width: canvasWidth, height: canvasHeight })
          
          // 直接使用比例轉換，因為輸入坐標已經是標準化的 (0-1)
          const x1 = bounding_box[0] * canvasWidth
          const y1 = bounding_box[1] * canvasHeight
          const x2 = bounding_box[2] * canvasWidth
          const y2 = bounding_box[3] * canvasHeight
          const x3 = bounding_box[4] * canvasWidth
          const y3 = bounding_box[5] * canvasHeight
          const x4 = bounding_box[6] * canvasWidth
          const y4 = bounding_box[7] * canvasHeight

          // 使用左上角作為起點，計算寬度和高度
          const left = Math.min(x1, x2, x3, x4)
          const top = Math.min(y1, y2, y3, y4)
          const right = Math.max(x1, x2, x3, x4)
          const bottom = Math.max(y1, y2, y3, y4)

          const width = right - left
          const height = bottom - top

          console.log('Calculated mark position:', { top, left, width, height })

          this.markStyle = `top: ${top}px;left: ${left}px;width: ${width}px;height: ${height}px;border: 2px solid rgba(255, 0, 0, 0.8);position:absolute;`
          
          // 確保標注框可見
          this.scrollToMark(top)
        })
      } else {
        console.log('Clearing mark style')
        this.markStyle = ''
      }
    },
    reSetMarkStyle() { // 重置标注框样式
      this.markStyle = ''
    },
    // 获取到pdf总页数时触发 会传入总页数
    getTotalPage(page) {
      this.pageTotal = page
    },
    // 初始化加载完毕触发
    mountedLoaded() {
      // 去除遮罩
      this.boxLoading = false
      this.$emit('mountedLoaded', this.pageTotal)
    },
    // 每加载完成一页时触发(初始化/翻页时均会触发)
    pageLoaded() {
      // 重新设置pdf预览区域容器外容器的尺寸
      this.setPdfBoxSize()
    },
    // 设置pdf预览区域容器的缩放尺寸
    getPdfSize() {
      return {
        transform: `scale(${this.pageScale})`
      }
    },
    // 点击缩放时触发
    scalePage(type) {
      // 改变缩放比例
      let sacle = 0
      if (type === '+') {
        sacle = this.pageScale + 0.1
      } else {
        sacle = this.pageScale - 0.1
      }
      // 可能会涉及js的精度损失 保留一位小数即可
      this.pageScale = Number(sacle.toFixed(1))
      // 缩放后pdf预览区域容器中会有留白 重新设置pdf预览区域容器外容器的尺寸
      this.setPdfBoxSize()
    },
    // 方法 翻页
    chengPage(type) {
      this.pageInputValue = ''
      // 防抖 0.5秒内不再次触发时执行
      if (this.pageChangeTimer) {
        clearTimeout(this.pageChangeTimer)
      }
      // 执行翻页
      this.pageChangeTimer = setTimeout(() => {
        if (type === '+') {
          this.currentPage += 1
        } else {
          this.currentPage -= 1
        }
        this.$emit('pageChange', this.currentPage)
        // 翻页后将滚动条归位到顶部
        this.scrollbarReset()
        this.pageChangeTimer = null
      }, 500)
    },
    pageChangeEnter() { // 输入框跳转页面
      // 防抖 0.5秒内不再次触发时执行
      if (this.pageChangeTimer) {
        clearTimeout(this.pageChangeTimer)
      }
      // 执行翻页
      this.pageChangeTimer = setTimeout(() => {
        let page = Number(this.pageInputValue)
        if (page > this.pageTotal) {
          page = this.pageTotal
        } else if (page < 1) {
          page = 1
        }
        this.pageInputValue = page
        this.currentPage = page
        this.$emit('pageChange', this.currentPage)
        // 翻页后将滚动条归位到顶部
        this.scrollbarReset()
        this.pageChangeTimer = null
      }, 500)
    },
    // 方法 滚动条归位到顶部
    scrollbarReset() {
      const boxDom = document.querySelector('.scroll-box')
      boxDom.scrollTop = 0
    },
    // 方法 设置pdf预览区域容器外容器的尺寸
    setPdfBoxSize() {
      // 缩放后 pdf的显示上会缩小 但元素的实际占地尺寸不会变化(仍是原尺寸) 导致可能会出现部分区域留白 通过改变pdf预览区域容器外容器的尺寸 来将留白区域hidden
      // 获取pdf的原尺寸
      const boxDom = document.querySelector('.pdf-scale-box')
      // 获取要设置尺寸的元素dom
      const setDom = document.querySelector('.pdf-box')
      // 如有缩放 高度根据缩放比例变化(48px是预留的上下外边距)
      if (this.pageScale !== 2 && boxDom && setDom) {
        setDom.style.height = `${boxDom.clientHeight * this.pageScale + 48}px`
      } else {
        setDom.style.height = ''
      }
      // console.log(this.pageScale)
      // console.log(boxDom.clientWidth *  this.pageScale)
    },
    rotatePdf() {
      // this.$nextTick(() => {
      //   const pdfElement = this.$refs.myPdf.$el.firstChild
      //   pdfElement.style.transform = `rotate(${this.rotateAngle}deg)` // 这里可以设置任意角度进行旋转
      // })
      // 旋转
      // 获取pdf的原尺寸
      const boxDom = document.querySelector('.pdf-scale-box')
      // 获取要设置角度的元素dom
      const setDom = document.querySelector('.pdf-box')
      // 设置旋转
      if (boxDom && setDom) {
        setDom.style.transform = `rotate(${this.rotateAngle}deg)`
      } else {
        setDom.style.transform = ''
      }
    },
    rotateCounterclockwise() {
      this.rotateAngle -= 90
      this.rotatePdf()
    },
    rotateClockwise() {
      this.rotateAngle += 90
      this.rotatePdf()
    },
    // 添加新方法来滚动到标注位置
    scrollToMark(top) {
      const scrollBox = document.querySelector('.scroll-box')
      if (scrollBox) {
        scrollBox.scrollTop = top - 100 // 减去一些偏移以确保标注框完全可见
      }
    }
  }
}
</script>

<style lang="less" scoped>
.pdf-preview-out {
  height: 100%;
  display: flex;
  flex-direction: column;
  // border: 1px solid #909;
  &, div {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  // 滚动容器
  .scroll-box {
    // 高度按比例 溢出滚动
    flex: 1;
    min-height: 0; // Important for flex child scrolling
    overflow: auto;
    border: 2px solid #c0d8f3;
    border-bottom: none;
    border-radius: 6px;
    background-color: #eeeeee;
    // 滚动条样式
    &::-webkit-scrollbar {
      width: 10px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #c0d8f3;
      border-radius: 6px;
    }
    &::-webkit-scrollbar-track {
      background-color: transparent;
      border-radius: 6px;
    }
    // 用于缩放后截取掉不需要的空白的容器
    .pdf-box {
      //overflow: hidden;
      padding: 24px;
      // border: 1px solid rgb(165, 11, 236);
    }
    // pdf预览区容器
    .pdf-scale-box {
      box-shadow: 0px 0px 20px 5px #666565;
      // border: 2px solid #090;
      // 设置缩放的中心点
      //transform-origin: center top;
      transform-origin: left top;
      transition: .2s;
    }
  }
  .bottom-tools {
    height: 56px;
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    margin-top: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    position: relative;

    .page-info {
      color: #606266;
      font-size: 14px;
      margin-right: 16px;
      min-width: 100px;
    }

    .page {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-right: 200px;

      .page-jump {
        display: flex;
        align-items: center;
        margin-left: 16px;
        
        span {
          color: #606266;
          font-size: 14px;
          margin: 0 8px;
        }

        .el-input {
          width: 60px;
          
          /deep/ .el-input__inner {
            text-align: center;
            padding: 0 8px;
          }
        }
      }

      .el-button {
        padding: 8px 16px;
        min-width: 90px;
        
        [class^="el-icon-"] {
          margin: 0 4px;
        }
      }
    }

    .tools-group {
      position: absolute;
      right: 16px;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      align-items: center;
      background-color: #fff;
      padding: 0 8px;

      .scale {
        display: flex;
        align-items: center;
        gap: 8px;

        .el-button {
          width: 32px;
          height: 32px;
          padding: 0;
          display: flex;
          align-items: center;
          justify-content: center;

          i {
            font-size: 14px;
          }
        }
      }

      .divider {
        width: 1px;
        height: 24px;
        background-color: #dcdfe6;
        margin: 0 12px;
        flex-shrink: 0;
      }
    }

    .el-button.is-disabled {
      color: #c0c4cc;
      background-color: #f5f7fa;
      border-color: #e4e7ed;
    }
  }
  ::-webkit-scrollbar { //隐藏滚动条
    width: 0;
    height: 10px;
    background-color: #ccc;
  }
}
</style>
